'use client';

import { c as _c } from "react/compiler-runtime";
import { StatsCard } from '@/shared/components/ui';
import { FeatherActivity, FeatherAlertCircle, FeatherCheckCircle, FeatherClock } from '@subframe/core';
interface NegotiacoesStatsProps {
  resultsLabel: string;
  resultsValue: string;
  needsActionLabel: string;
  needsActionValue: string;
  overdueLabel: string;
  overdueValue: string;
  concludedLabel: string;
  concludedValue: string;
}
export function NegotiacoesStats(t0) {
  const $ = _c(21);
  const {
    resultsLabel,
    resultsValue,
    needsActionLabel,
    needsActionValue,
    overdueLabel,
    overdueValue,
    concludedLabel,
    concludedValue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherActivity className="text-brand-600 h-5 w-5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== resultsLabel || $[2] !== resultsValue) {
    t2 = <StatsCard label={resultsLabel} value={resultsValue} icon={t1} />;
    $[1] = resultsLabel;
    $[2] = resultsValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherAlertCircle className="text-warning-600 h-5 w-5" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== needsActionLabel || $[6] !== needsActionValue) {
    t4 = <StatsCard label={needsActionLabel} value={needsActionValue} icon={t3} />;
    $[5] = needsActionLabel;
    $[6] = needsActionValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherClock className="text-error-600 h-5 w-5" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== overdueLabel || $[10] !== overdueValue) {
    t6 = <StatsCard label={overdueLabel} value={overdueValue} icon={t5} />;
    $[9] = overdueLabel;
    $[10] = overdueValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherCheckCircle className="text-success-600 h-5 w-5" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== concludedLabel || $[14] !== concludedValue) {
    t8 = <StatsCard label={concludedLabel} value={concludedValue} icon={t7} />;
    $[13] = concludedLabel;
    $[14] = concludedValue;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{t2}{t4}{t6}{t8}</div>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}